module.exports = __webpack_public_path__ + "static/media/icon-cards.4005c4ed.svg";